import _defineProperty from "/codebuild/output/src3618121175/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { Keyframes } from '@ant-design/cssinjs';
import { CONTAINER_MAX_OFFSET } from '../../_util/hooks/useZIndex';
import { resetComponent } from '../../style';
import { genStyleHooks, mergeToken } from '../../theme/internal';
var genMessageStyle = function genMessageStyle(token) {
  var componentCls = token.componentCls,
    iconCls = token.iconCls,
    boxShadow = token.boxShadow,
    colorText = token.colorText,
    colorSuccess = token.colorSuccess,
    colorError = token.colorError,
    colorWarning = token.colorWarning,
    colorInfo = token.colorInfo,
    fontSizeLG = token.fontSizeLG,
    motionEaseInOutCirc = token.motionEaseInOutCirc,
    motionDurationSlow = token.motionDurationSlow,
    marginXS = token.marginXS,
    paddingXS = token.paddingXS,
    borderRadiusLG = token.borderRadiusLG,
    zIndexPopup = token.zIndexPopup,
    contentPadding = token.contentPadding,
    contentBg = token.contentBg;
  var noticeCls = "".concat(componentCls, "-notice");
  var messageMoveIn = new Keyframes('MessageMoveIn', {
    '0%': {
      padding: 0,
      transform: 'translateY(-100%)',
      opacity: 0
    },
    '100%': {
      padding: paddingXS,
      transform: 'translateY(0)',
      opacity: 1
    }
  });
  var messageMoveOut = new Keyframes('MessageMoveOut', {
    '0%': {
      maxHeight: token.height,
      padding: paddingXS,
      opacity: 1
    },
    '100%': {
      maxHeight: 0,
      padding: 0,
      opacity: 0
    }
  });
  var noticeStyle = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
    padding: paddingXS,
    textAlign: 'center'
  }, "".concat(componentCls, "-custom-content"), {
    display: 'flex',
    alignItems: 'center'
  }), "".concat(componentCls, "-custom-content > ").concat(iconCls), {
    marginInlineEnd: marginXS,
    // affected by ltr or rtl
    fontSize: fontSizeLG
  }), "".concat(noticeCls, "-content"), {
    display: 'inline-block',
    padding: contentPadding,
    background: contentBg,
    borderRadius: borderRadiusLG,
    boxShadow: boxShadow,
    pointerEvents: 'all'
  }), "".concat(componentCls, "-success > ").concat(iconCls), {
    color: colorSuccess
  }), "".concat(componentCls, "-error > ").concat(iconCls), {
    color: colorError
  }), "".concat(componentCls, "-warning > ").concat(iconCls), {
    color: colorWarning
  }), "".concat(componentCls, "-info > ").concat(iconCls, ",\n      ").concat(componentCls, "-loading > ").concat(iconCls), {
    color: colorInfo
  });
  return [// ============================ Holder ============================
  _defineProperty({}, componentCls, Object.assign(Object.assign({}, resetComponent(token)), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
    color: colorText,
    position: 'fixed',
    top: marginXS,
    width: '100%',
    pointerEvents: 'none',
    zIndex: zIndexPopup
  }, "".concat(componentCls, "-move-up"), {
    animationFillMode: 'forwards'
  }), "\n        ".concat(componentCls, "-move-up-appear,\n        ").concat(componentCls, "-move-up-enter\n      "), {
    animationName: messageMoveIn,
    animationDuration: motionDurationSlow,
    animationPlayState: 'paused',
    animationTimingFunction: motionEaseInOutCirc
  }), "\n        ".concat(componentCls, "-move-up-appear").concat(componentCls, "-move-up-appear-active,\n        ").concat(componentCls, "-move-up-enter").concat(componentCls, "-move-up-enter-active\n      "), {
    animationPlayState: 'running'
  }), "".concat(componentCls, "-move-up-leave"), {
    animationName: messageMoveOut,
    animationDuration: motionDurationSlow,
    animationPlayState: 'paused',
    animationTimingFunction: motionEaseInOutCirc
  }), "".concat(componentCls, "-move-up-leave").concat(componentCls, "-move-up-leave-active"), {
    animationPlayState: 'running'
  }), '&-rtl', {
    direction: 'rtl',
    span: {
      direction: 'rtl'
    }
  }))), // ============================ Notice ============================
  _defineProperty({}, componentCls, _defineProperty({}, "".concat(noticeCls, "-wrapper"), Object.assign({}, noticeStyle))), // ============================= Pure =============================
  _defineProperty({}, "".concat(componentCls, "-notice-pure-panel"), Object.assign(Object.assign({}, noticeStyle), {
    padding: 0,
    textAlign: 'start'
  }))];
};
export var prepareComponentToken = function prepareComponentToken(token) {
  return {
    zIndexPopup: token.zIndexPopupBase + CONTAINER_MAX_OFFSET + 10,
    contentBg: token.colorBgElevated,
    contentPadding: "".concat((token.controlHeightLG - token.fontSize * token.lineHeight) / 2, "px ").concat(token.paddingSM, "px")
  };
};
// ============================== Export ==============================
export default genStyleHooks('Message', function (token) {
  // Gen-style functions here
  var combinedToken = mergeToken(token, {
    height: 150
  });
  return [genMessageStyle(combinedToken)];
}, prepareComponentToken);